export const USStates = [
  { label: 'Alabama (AL)', value: 'AL' },
  { label: 'Alaska (AK)', value: 'AK' },
  { label: 'Arizona (AZ)', value: 'AZ' },
  { label: 'Arkansas (AR)', value: 'AR' },
  { label: 'California (CA)', value: 'CA' },
  { label: 'Colorado (CO)', value: 'CO' },
  { label: 'Connecticut (CT)', value: 'CT' },
  { label: 'Delaware (DE)', value: 'DE' },
  { label: 'District of Columbia (DC)', value: 'DC' },
  { label: 'Florida (FL)', value: 'FL' },
  { label: 'Georgia (GA)', value: 'GA' },
  { label: 'Hawaii (HI)', value: 'HI' },
  { label: 'Idaho (ID)', value: 'ID' },
  { label: 'Illinois (IL)', value: 'IL' },
  { label: 'Indiana (IN)', value: 'IN' },
  { label: 'Iowa (IA)', value: 'IA' },
  { label: 'Kansas (KS)', value: 'KS' },
  { label: 'Kentucky (KY)', value: 'KY' },
  { label: 'Louisiana (LA)', value: 'LA' },
  { label: 'Maine (ME)', value: 'ME' },
  { label: 'Maryland (MD)', value: 'MD' },
  { label: 'Massachusetts (MA)', value: 'MA' },
  { label: 'Michigan (MI)', value: 'MI' },
  { label: 'Minnesota (MN)', value: 'MN' },
  { label: 'Mississippi (MS)', value: 'MS' },
  { label: 'Missouri (MO)', value: 'MO' },
  { label: 'Montana (MT)', value: 'MT' },
  { label: 'Nebraska (NE)', value: 'NE' },
  { label: 'Nevada (NV)', value: 'NV' },
  { label: 'New Hampshire (NH)', value: 'NH' },
  { label: 'New Jersey (NJ)', value: 'NJ' },
  { label: 'New Mexico (NM)', value: 'NM' },
  { label: 'New York (NY)', value: 'NY' },
  { label: 'North Carolina (NC)', value: 'NC' },
  { label: 'North Dakota (ND)', value: 'ND' },
  { label: 'Ohio (OH)', value: 'OH' },
  { label: 'Oklahoma (OK)', value: 'OK' },
  { label: 'Oregon (OR)', value: 'OR' },
  { label: 'Pennsylvania (PA)', value: 'PA' },
  { label: 'Rhode Island (RI)', value: 'RI' },
  { label: 'South Carolina (SC)', value: 'SC' },
  { label: 'South Dakota (SD)', value: 'SD' },
  { label: 'Tennessee (TN)', value: 'TN' },
  { label: 'Texas (TX)', value: 'TX' },
  { label: 'Utah (UT)', value: 'UT' },
  { label: 'Vermont (VT)', value: 'VT' },
  { label: 'Virginia (VA)', value: 'VA' },
  { label: 'Washington (WA)', value: 'WA' },
  { label: 'West Virginia (WV)', value: 'WV' },
  { label: 'Wisconsin (WI)', value: 'WI' },
  { label: 'Wyoming (WY)', value: 'WY' },
]

export const stateToZip: { [key: string]: string } = {
  AL: '35004',
  AK: '99501',
  AZ: '85001',
  AR: '71601',
  CA: '90001',
  CO: '80201',
  CT: '06101',
  DE: '19901',
  DC: '20001',
  FL: '33101',
  GA: '30301',
  HI: '96801',
  ID: '83701',
  IL: '60601',
  IN: '46201',
  IA: '50301',
  KS: '66101',
  KY: '40201',
  LA: '70112',
  ME: '04101',
  MD: '21201',
  MA: '02101',
  MI: '48201',
  MN: '55101',
  MS: '39530',
  MO: '63101',
  MT: '59001',
  NE: '68101',
  NV: '89501',
  NH: '03301',
  NJ: '07001',
  NM: '87501',
  NY: '10001',
  NC: '27501',
  ND: '58102',
  OH: '44101',
  OK: '73101',
  OR: '97201',
  PA: '19101',
  RI: '02901',
  SC: '29201',
  SD: '57101',
  TN: '37201',
  TX: '73301',
  UT: '84101',
  VT: '05601',
  VA: '23218',
  WA: '98001',
  WV: '25301',
  WI: '53201',
  WY: '82001',
}

export const titleOptions = ['Mr.', 'Mrs.', 'Ms.', 'Dr.']
export const pronounOptions = ['', 'He', 'She', 'Other']
export const genderOptions = ['Male', 'Female', 'Other']
export const maritalStatusOptions = [
  'Married',
  'Single',
  'Divorced',
  'Widowed',
  'Separated',
  'Other',
]
